import { UAParser } from 'ua-parser-js';
export enum EWebViewActions {
    OPEN_WEB_VIEW = 'open_webview',
    ASK_LOCATION_PERMISSION = 'ask_location_permission',
    CAMERA_PERMISSION = 'web_permission',
    NATIVE_BACK_PRESS = 'native_back_press',
    CAN_USE_NATIVE_BACK_PRESS = 'can_use_native_back_press',
    CLOSE_WEB_VIEW = 'close_webview',
    INTENT = 'intent',
}

export interface IWebViewActionData {
    action: EWebViewActions;
    action_value: {
        url?: string;
    } | null;
}
export interface IParsedUA {
    isMobile: boolean;
    device: keyof typeof UAParser.DEVICE;
    browser: string;
}

export interface IImage {
    imageName: string;
    imageUrl: string;
}

export enum EVehicleType {
    PCV_CAR = 'PCV_CAR',
    PCV_BIKE = 'PCV_BIKE',
    GCV = 'GCV',
    PRIVATE_BIKE = 'PRIVATE_BIKE',
    PRIVATE_CAR = 'PRIVATE_CAR',
}

export interface IPageLoadError {
    statusCode: number;
    statusText: string;
    ekey?: string;
    eReqID?: string;
    status?: any;
}

export interface IParsedUA {
    isMobile: boolean;
    device: keyof typeof UAParser.DEVICE;
    browser: string;
}

export interface IVehicleDetails {
    vehicle_make?: string;
    vehicle_model?: string;
    variant?: string;
    vehicle_number?: string;
    photo?: string;
    fuel_type?: string;
    registration_year?: number;
    vehicle_name?: string;
    variant_name?: string;
    pincode?: string;
    isVISData?: boolean;
    model_id?: number;
    color?: string;
}

interface VehicleDetails {
    registration_number: string;
    model_id: number;
    make: string;
    model: string;
}

interface PricingDetails {
    base_amount: string;
    discounted_amount: string;
}
export interface BookingType {
    date: string;
    slot_id?: string;
    location_details: Location;
    vehicle_details: VehicleDetails;
    pricing_details: PricingDetails;
}
export type Slot = {
    date: string;
    slots: Array<{
        id: string | null;
        startTime: string;
        endTime: string;
        count: number;
        isSameDayService: boolean;
        disabled: boolean;
    }>;
};

export interface IAvailableSlots extends Array<Slot> {}

export enum DEVICES {
    WEB = 'web',
    MWEB = 'mWeb',
}

export interface IGarageDetails {
    id: string;
    name: string;
    display_name: string;
    address: string;
    display_address: string;
    pincode: string;
    rating: string;
    sa_phone_number: string | null;
    sa_name: string | null;
    royalty: {
        royalty_amount: number | null;
        royalty_percent: number;
        cgst_percent: number;
        sgst_percent: number;
        igst_percent: number;
    } | null;
    is_final_bill_adjustable: boolean | null;
    appointment_pricing: {
        SLOT_BOOKING?: { amount: number };
        PICK_AND_DROP?: { amount: number };
        SELF_DROP?: { amount: number };
    } | null;
    serviceable_pincodes: number[] | null;
    standard_discount: number | null;
    pricing_markup: {
        OTHER_GARAGE_MARKUP?: number;
        ADSC_MARKUP?: number;
    } | null;
    map_link: string | null;
    reception_number: string;
    is_variable_price_applicable: boolean | null;
    serviceable_make: string[] | null;
    reschedule_window_in_hours: number;
    cancellation_window_in_hours: number;
    appointment_expiration_window_in_minutes: number | null;
    city: string | null;
    location: {
        description: string;
        line: string;
        city: string;
        state: string;
        pincode: string;
        house_number: string | null;
        locality: string;
        location_coords: {
            latitude: number;
            longitude: number;
        };
    } | null;
    garage_landing_path: string;
    google_maps_place_id: string | null;
    working_hours: {
        PICK_AND_DROP?: {
            working_start_time: string;
            working_end_time: string;
        };
        SELF_DROP?: {
            working_start_time: string;
            working_end_time: string;
        };
    };
}

export interface IParsedGarageDetails {
    garageName: string;
    garageAddress: string;
    garageRating: number;
    city: string | null;
    pincode: string | number;
    garageId: string;
    garageDisplayAddress?: string;
    garageMapLink?: string;
    garageLandingPath?: string;
}

export interface IRepeatBookingInfo {
    pickup_details: {
        address: {
            description: string;
            line: string;
            city: string;
            state: string;
            pincode: string;
            house_number: string;
            locality: string;
            location_coords: {
                latitude: number;
                longitude: number;
            };
        };
    };
    garage_id: string;
    appointment_id: string;
    vehicle_details: {
        make: string;
        model: string;
        model_id: number;
        fuel_type: string;
        color: string;
        vin: string;
    };
}

export interface IServiceReminder {
    carNo: string;
    serviceType: string;
    nextServiceDate: string;
    lastServiceDate: string;
    appointmentId: string;
    garageId: string;
}

export enum RewardValueTypeEnum {
    FIXED = 'FIXED',
    PERCENTAGE = 'PERCENTAGE',
    CUSTOM = 'CUSTOM',
}

export enum RewardTypeEnum {
    TARGETTED = 'TARGETTED',
    PUBLIC = 'PUBLIC',
}

export enum RewardStatus {
    APPLIED = 'APPLIED',
    REDEEMED = 'REDEEMED',
    REVOKED = 'REVOKED',
}

export interface Meta extends RewardConditions {
    tags?: string[];
    reward_value?: string;
}

export interface CouponBase {
    coupon_id: string;
    coupon_code?: string;
    title: string;
    description: string;
    terms_and_conditions: string;
    start_on: string;
    expire_on: string;
    hidden: boolean;
    pseudo: boolean;
}
export interface Coupon extends CouponBase {
    coupon_value_type?: RewardValueTypeEnum;
    value_discount?: number;
    maxReward_value?: number;
    reward_value?: number;
    rule?: string;
    applicable?: boolean;
    meta?: Meta;
}
export interface FetchRewardResponseDto {
    coupons?: Coupon[];
}

export interface ExtractRewardResponseDto {
    coupons?: Coupon[];
}

export interface RewardConditions {
    garage_id?: string;
    service_type?: string;
    package_name?: string;
    service_name?: string;
    utm_medium?: string;
    is_first_service?: string;
}

export interface ApplyData extends RewardConditions {
    total_amount?: number;
    package_amount?: number;
    service_amount?: number;
}

export interface PricingDto {
    garage_id?: string;
    model_id?: number;
    fuel_type?: string;
}

export interface ExtractRewardResponseDto {
    coupons?: Coupon[];
}

export interface RewardDetails {
    reward_id: string;
    reward_type: RewardTypeEnum;
    reward_value_type: RewardValueTypeEnum;
    reward_status?: RewardStatus;
    reward_transaction_id?: string;
    reward_value: number;
    apply_data: ApplyData;
}

export type FilteredCarDetails = {
    acko_model_id?: string;
    model_name?: string;
    make_name?: string;
    fuel_type?: string;
    registration_year?: string;
    color?: string;
    acko_variant_id?: string;
    variant_name?: string;
    registration_number?: string;
};

export interface IPincodeData {
    city: string;
    lat: number;
    lon: number;
    query: string;
    status: string;
    zip: string;
}

export type CDPData = {
    pincode: number;
    garage_id: string;
};

export interface GarageCardDetails {
    imageUrls: string[];
    garageVideo: string | null;
    rating: string | number;
    serviceableAreas: string[] | number[];
    workingTime: string | null;
    lat: number;
    long: number;
    locationInfo: string | null;
    garageName: string;
    earliestSlotTime: string | null;
    mapLink: string | null;
    pincode: string | number | undefined;
    garageId: string | null;
}

export interface PincodeFromLatitudeLongitudeRequest {
    latitude: number;
    longitude: number;
}

export interface PincodeFromLatitudeLongitudeResponse {
    pincode: string;
    city: string;
    state: string;
    country: string;
    garage_id?: string;
    garageId?: string;
}

export interface PincodeByGarageIdResponse {
    pincode: string;
    garage_id?: string;
}
